export default () => ({
  entities: 'rules',
  rules: []
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/summary-agenda/resources/data.js